// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._6Tr9KER2x{color:#d94a41;font-size:0.9em}\n", ""]);
// Exports
exports.locals = {
	"failed": "_6Tr9KER2x"
};
module.exports = exports;
